var temData
var temStr

export function calStr(expr) {
  temData = new Array();
  temStr = new Array();
  IntoStack(expr);
  let result  = SS();
  return result
}

function IntoStack(str) {
  var strs = "";
  for (var i = 0; i < str.length; i++) {
    switch (str[i]) {
      case '*':
      case '+':
      case '-':
      case '/':
      case '(':
        if (strs.length > 0) {
          temData.push(parseFloat(strs));
          strs = '';
        }
        if (str[i] != '(') {
          JiSuan(str[i]);
        }
        temStr.push(str[i]);
        break;
      case ')':
        if (strs.length > 0) {
          temData.push(parseFloat(strs));
          strs = '';
        }
        Kh();
        break;
      default:
        strs += str[i];
        break;
    }
  }
  if (strs != '') {
    temData.push(parseFloat(strs));
  }
}

function Kh() {
  var expr = temStr.pop();
  var data1;
  var data;
  var data2;
  while (expr != '(') {
    data1 = temData.pop();
    data2 = temData.pop();
    data = Calculate(data2, data1, expr);
    temData.push(data);
    expr = temStr.pop();
  };
  var s = 's';
}


function JiSuan(str) {
  if (Priority(str) <= Priority(temStr[temStr.length - 1])) {
    var data1 = temData.pop();
    var data2 = temData.pop();
    var expr = temStr.pop();
    var data = Calculate(data2, data1, expr);
    temData.push(data);
  }
}
function SS() {
  for (var i = temStr.length - 1; i >= 0; i--) {
    var data1 = temData.pop();
    var data2 = temData.pop();
    var expr = temStr[i];
    var data = Calculate(data2, data1, expr);
    temData.push(data);
    return data
  }
}

function Priority(expr) {  ///优先级别
  var result = 0;
  switch (expr) {
    case '*':
    case '/':
      result = 2;
      break;

    case '-':
    case '+':
      result = 1;
      break;

    case '(':
      result = 0;
      break;

    case ')':
      result = 3;
      break;
    default:
      result = -1;
      break;
  }
  return result;
}
function Calculate(data1, data2, expr) {
  var result = 0;
  switch (expr) {
    case '*':
      result = data1 * data2;
      break;
    case '/':
      result = data1 / data2;
      break;
    case '-':
      result = data1 - data2;
      break;
    case '+':
      result = data1 + data2;
      break;
    default: return 0;
  }
  return result;
}
